// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import SwapOutlinedSvg from "@ant-design/icons-svg/lib/asn/SwapOutlined";
import AntdIcon from "../components/AntdIcon";
const SwapOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: SwapOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    SwapOutlined.displayName = "SwapOutlined";
}
export default /*#__PURE__*/ React.forwardRef(SwapOutlined);
